export const getSafeRedirectUrl = (redirectUrl, baseUrl) => {
  try {
    const url = new URL(redirectUrl);
    const domain = new URL(baseUrl).hostname.split('.').slice(-2).join('.');
    const isOwnHost = url.hostname === domain || url.hostname.endsWith(`.${domain}`);
    const isAllowedProtocol = url.protocol === 'https:' || (process.env.ENV === 'LOCAL' && url.protocol === 'http:');

    return isAllowedProtocol && isOwnHost ? url.href : undefined;
  } catch {
    return undefined;
  }
};
